<template lang="pug">
  app-modal(
    :titulo="titulo",
    :width="width"
    @closeModal="$emit('closeModal')"
  )
    template(slot="body")
      app-pdf-viewer(
        v-if="bytes"
        :bytes = "bytes"
      )
    template(slot="footer")
      div.flex
        el-button(@click="downloadPdf")
          i.fal.fa-file-pdf
          span &nbsp Exportar PDF

</template>

<script>
import AppModal from '@/components/AppModal'
import AppPdfViewer from '@/components/AppPDFViewer'
import FileHelper from '@/utils/fileHelper'

export default {
  components: {
    AppModal,
    AppPdfViewer,
    FileHelper
  },

  props: {
    titulo: { required: true, type: String },
    width: { default: 1024, type: Number },
    bytes: { required: true, type: ArrayBuffer }
  },

  methods: {
    downloadPdf () {
      FileHelper.saveFile(this.bytes, 'portaria.pdf')
    }
  }
}
</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}

.flex {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gp/components/portaria/VisualizarPortaria.vue